import React from 'react';
import ChangePasswordSection from '../../../components/shared/ChangePasswordSection.jsx';

export default function SponsorSettings() {
  return (
    <div className="max-w-lg mx-auto space-y-4">
      <div className="card overflow-hidden flex">
        <div className="w-1 bg-accent flex-shrink-0" />
        <div className="p-5 flex-1">
          <h1 className="text-[18px] font-bold text-text leading-tight">Account Settings</h1>
          <p className="text-sm text-text-muted mt-1">Manage your account security.</p>
        </div>
      </div>
      <ChangePasswordSection />
    </div>
  );
}
